import { type ChangeEvent, useCallback } from 'react';
import type { Lens } from '@hookform/lenses';
import { useController } from 'react-hook-form';
import { CheckboxInput, type CheckboxInputProps } from '@interxfi/design-system/components/input/checkbox-input/checkbox-input';

interface PropsWithLens extends Omit<CheckboxInputProps, 'name' | 'value' | 'checked'> {
  lens: Lens<boolean>;
  shouldUnregister?: boolean;
}

export function AppCheckboxInputWithLens({ onChange, shouldUnregister, lens, ...props }: PropsWithLens) {
  const { field, fieldState } = useController({ shouldUnregister, ...lens.interop() });
  const fieldOnChange = field.onChange;
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      fieldOnChange?.(e.target.value);
      onChange?.(e);
    },
    [fieldOnChange, onChange],
  );

  return <CheckboxInput {...props} {...field} checked={field.value ?? false} error={fieldState.error?.message} onChange={handleChange} />;
}
